import { Statistic } from "antd";

const POSITIVE_COLOR = "#16a34a";
const NEGATIVE_COLOR = "#dc2626";

const ColoredStatistic = ({ title, value, precision = 2, prefix, suffix, props }) => {
  if (value === null || isNaN(value)) {
    return null;
  }
  const color = parseFloat(value) > 0 ? POSITIVE_COLOR : NEGATIVE_COLOR;
  const displayPrefix = prefix ? `${prefix}` : undefined;

  switch (displayPrefix) {
    case "TRX":
    case "ETH":
      precision = 8;
      break;
    default:
      precision = 2;
  }

  return (
    <Statistic
      title={title}
      value={value}
      prefix={suffix}
      suffix={prefix}
      precision={precision}
      style={{ textAlign: "right" }}
      valueStyle={{ color, textAlign: "right" }}
      {...props}
    />
  );
};

export default ColoredStatistic;
